import { clarityEvent, claritySet } from '@/lib/analytics/clarity';
import type { TFeatureLeadFormData } from '@/lib/interfaces/forms/featureLeadForm.types';

export async function submitFeatureLead(data: TFeatureLeadFormData) {
  const url = process.env.NEXT_PUBLIC_FORM_SPREE_URL;
  if (!url) throw new Error('Missing NEXT_PUBLIC_FORM_SPREE_URL');

  const res = await fetch(url, {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({
      name: `${data.firstName} ${data.lastName}`.trim(),
      company: data.company,
      mobile: data.mobile,
      _replyto: data.email,
      feature: data.feature,
      roles: data.roles?.join(', '),
      message: data.message,
      _subject: `Feature form submission - ${data.feature}`,
    }),
  });

  if (!res.ok) throw new Error('Failed to send feature lead');
  if (data.feature) claritySet('feature', data.feature);
  clarityEvent('feature_lead_form_submitted');
  return true;
}
